module.exports = __webpack_public_path__ + "media/images/pen_green-ac1b90c3.png";